"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endpoints = undefined;

var _contentSecurityPolicy = require("../content-security-policy");

var _general = require("../../helpers/general");

/* Adding to directives arrays in each endpoint file's global scope, or in each csp_policy function, prior to
 * using makePolicy with the directives, will allow individual endpoints to specify which policy to use.
 * For example:
 *      directives["script-src"].push("http://someDomain.com")
 * This will add someDomain.com to our white list of domains, which is allowed to execute scripts in the app.
 */

var addLocalWhitelists = function addLocalWhitelists(directives) {
  /* Unsafe-eval for local development is necessary for best experience with Webpack builds */
  directives["style-src"].push("blob:");
  directives["script-src"].push("'unsafe-eval'");
  directives["script-src"].push("'unsafe-inline'");
  directives["connect-src"].push("http://localhost:*");
};

var endpoints = exports.endpoints = {
  development: {
    mobile_api_url: "/dev/api/system",
    system_api_url: "/dev/api/system",
    handshake_api_url: "/dev/api/handshake",
    assets_url: "/dev/api/assets",
    yahoo_api_url: "/dev/api/yahoo",
    pinterest_api_url: "/dev/api/pinterest",
    trivu_api_url: "/dev/api/trivu",
    trivu_v2_api_url: "/dev/api/tubetop",
    facebook_api_url: "/dev/api/facebook",
    facebook_app_id: "213476522140811",
    facebook_v2_api_url: "/dev/api/facebook_v2",
    facebook_v3_api_url: "/dev/api/facebook_v3",
    facebook_self_serve_app_id: "243863395812506",
    web_app_url: "http://adparlor.local/adparlor_1812_frontend/",
    twitter_api_url: "/dev/api/twitter",
    banana_api_url: "/dev/api/banana",
    ruler_api_url: "/dev/api/ruler",
    graffiti_api_url: "/dev/api/graffiti",
    snapchat_api_url: "/dev/api/casper",
    enable_facebook: "true",
    enable_twitter: "true",
    enable_yahoo: "false",
    enable_pinterest: "false",
    enable_snapchat: "false",
    logentries_key: "90af9377-f436-485b-89a6-c6cb98ce5541",
    filepicker_key: "A0p6RRB0FS6uKOEFJ2Dr2z",
    S3_container: "sor-filepicker",
    csp_policy: function () {
      var directives = (0, _contentSecurityPolicy.getDirectives)();
      addLocalWhitelists(directives);
      return (0, _contentSecurityPolicy.makePolicy)(directives);
    }()
  },

  sandbox: {
    system_api_url: "https://system.api.sandbox.adparlordev.com/api",
    handshake_api_url: "https://handshake.api.sandbox.adparlordev.com/v1",
    assets_url: "https://system.api.sandbox.adparlordev.com",
    facebook_api_url: "https://facebook-v1.api.sandbox.adparlordev.com",
    facebook_v2_api_url: "https://facebook.api.sandbox.adparlordev.com/v2",
    facebook_v3_api_url: "https://facebook.api.sandbox.adparlordev.com/v3",
    facebook_app_id: "213476522140811",
    facebook_self_serve_app_id: "243863395812506",
    web_app_url: "https://app.sandbox.adparlordev.com",
    twitter_api_url: "https://twitter.api.sandbox.adparlordev.com/v6",
    banana_api_url: "https://banana.api.sandbox.adparlordev.com",
    ruler_api_url: "https://ruler.api.sandbox.adparlordev.com/v1",
    yahoo_api_url: "https://yahoo.api.sandbox.adparlordev.com/v1",
    pinterest_api_url: "https://pinterest.api.sandbox.adparlordev.com/v1",
    trivu_api_url: "https://trivu.api.sandbox.adparlordev.com/v2",
    vc_api_url: "https://tubetop.api.sandbox.adparlordev.com/v2",
    dbm_api_url: "https://dbm.api.sandbox.adparlordev.com/v1",
    graffiti_api_url: "https://graffiti-v2.api.sandbox.adparlordev.com/v1",
    snapchat_api_url: "https://snapchat.api.sandbox.adparlordev.com/v1",
    ripple_api_url: "https://ripple.api.sandbox.adparlordev.com/v1",
    crossroads_api_url: "https://crossroads.api.sandbox.adparlordev.com/v1",
    crossbow_api_url: "https://crossbow.api.sandbox.adparlordev.com/v1",
    hook_api_url: "https://hook.api.sandbox.adparlordev.com",
    cupid_api_url: "https://cupid.api.sandbox.adparlordev.com/v1",
    convention_api_url: "https://convention.api.sandbox.adparlordev.com",
    thumbsup_api_url: "https://thumbsup.api.sandbox.adparlordev.com",
    palette_api_url: "https://palette.api.sandbox.adparlordev.com/v1",
    picasso_api_url: "https://picasso.api.sandbox.adparlordev.com/v1",
    enable_facebook: "true",
    enable_twitter: "true",
    enable_yahoo: "false",
    enable_pinterest: "false",
    enable_snapchat: "false",
    enable_dbm: "false",
    enable_youtube: "false",
    enable_trivu: "false",
    logentries_key: "d6643746-e5cf-4637-a9cf-30fa1bf0f9f7",
    filepicker_key: "A0p6RRB0FS6uKOEFJ2Dr2z",
    S3_container: "ap-dev-filepicker",
    csp_policy: function () {
      var directives = (0, _contentSecurityPolicy.getDirectives)();
      directives["connect-src"].push("https://*.api.sandbox.adparlordev.com");
      directives["img-src"].push("https://*.api.sandbox.adparlordev.com");
      if (!(0, _general.isProdEnv)()) addLocalWhitelists(directives);
      return (0, _contentSecurityPolicy.makePolicy)(directives);
    }()
  },

  // ----------------------- DEPRECATED -----------------------
  quality: {
    mobile_api_url: "/quality/api/system",
    system_api_url: "/quality/api/system",
    assets_url: "/quality/api/assets",
    yahoo_api_url: "/quality/api/yahoo",
    pinterest_api_url: "/quality/api/pinterest",
    trivu_api_url: "/quality/api/trivu",
    trivu_v2_api_url: "/quality/api/tubetop",
    facebook_api_url: "/quality/api/facebook",
    facebook_app_id: "213476522140811",
    facebook_v2_api_url: "/quality/api/facebook_v2",
    facebook_v3_api_url: "/quality/api/facebook_v3",
    facebook_self_serve_app_id: "243863395812506",
    web_app_url: "http://localhost/adparlor_1812_frontend/index.html",
    twitter_api_url: "/quality/api/twitter",
    banana_api_url: "/quality/api/banana",
    ruler_api_url: "http://localhost:9777/v1",
    graffiti_api_url: "/quality/api/graffiti",
    snapchat_api_url: "/quality/api/casper",
    enable_facebook: "true",
    enable_twitter: "true",
    enable_yahoo: "true",
    enable_pinterest: "true",
    enable_snapchat: "true",
    logentries_key: "90af9377-f436-485b-89a6-c6cb98ce5541",
    filepicker_key: "A0p6RRB0FS6uKOEFJ2Dr2z",
    S3_container: "sor-filepicker",
    csp_policy: function () {
      var directives = (0, _contentSecurityPolicy.getDirectives)();
      if (!(0, _general.isProdEnv)()) addLocalWhitelists(directives);
      return (0, _contentSecurityPolicy.makePolicy)(directives);
    }()
  },

  production: {
    system_api_url: "https://system-api.adparlor.com/api",
    handshake_api_url: "https://handshake.api.adparlor.com/v1",
    assets_url: "https://system-api.adparlor.com",
    facebook_api_url: "https://facebook-v1-api.adparlor.com",
    facebook_v2_api_url: "https://facebook-api.adparlor.com/v2",
    facebook_v3_api_url: "https://facebook-api.adparlor.com/v3",
    facebook_app_id: "213476522140811",
    facebook_self_serve_app_id: "243863395812506",
    web_app_url: "https://app.adparlor.com",
    twitter_api_url: "https://twitter-api.adparlor.com/v6",
    banana_api_url: "https://banana-api.adparlor.com",
    ruler_api_url: "https://ruler-api.adparlor.com/v1",
    yahoo_api_url: "DEPRECATED",
    pinterest_api_url: "https://pinterest-api.adparlor.com/v1",
    trivu_api_url: "https://tubetop-api.adparlor.com/v2",
    vc_api_url: "https://tubetop-api.adparlor.com/v2",
    graffiti_api_url: "https://graffiti-v2.api.adparlor.com/v1",
    snapchat_api_url: "https://snapchat-api.adparlor.com/v1",
    ripple_api_url: "https://ripple-api.adparlor.com/v1",
    crossroads_api_url: "https://crossroads.api.adparlor.com/v1",
    crossbow_api_url: "https://crossbow.api.adparlor.com/v1",
    hook_api_url: "https://hook-api.adparlor.com",
    dbm_api_url: "https://decibel-api.adparlor.com/v1",
    cupid_api_url: "https://cupid.api.adparlor.com/v1",
    convention_api_url: "https://convention.api.adparlor.com",
    thumbsup_api_url: "https://thumbsup.api.adparlor.com",
    palette_api_url: "https://palette.api.adparlor.com/v1",
    picasso_api_url: "https://picasso.api.adparlor.com/v1",
    enable_facebook: "true",
    enable_twitter: "true",
    enable_yahoo: "false",
    enable_pinterest: "false",
    enable_snapchat: "false",
    enable_dbm: "false",
    enable_youtube: "false",
    enable_trivu: "false",
    logentries_key: "d6643746-e5cf-4637-a9cf-30fa1bf0f9f7",
    filepicker_key: "An5rln3AcQ5iIHRoWrR73z",
    S3_container: "ap-prod-filepicker",
    csp_policy: function () {
      var directives = (0, _contentSecurityPolicy.getDirectives)();
      if (!(0, _general.isProdEnv)()) addLocalWhitelists(directives);
      return (0, _contentSecurityPolicy.makePolicy)(directives);
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/js-anvil/lib/config/endpoints/index.js
// module id = 5
// module chunks = 0